<section class="academy-container">
  <div class="border-card-academy mat-elevation-z15">
    <div class="academy-info-card">
      <p
        class="title-gnrl"
        translate="academy.{{ currentCode }}.academy.title"
      ></p>
      <h1
        class="academy-sub-title"
        [innerHTML]="
          'academy.' + currentCode + '.academy.sub-title' | translate
        "
      ></h1>
      <p
        class="academy-description-head"
        translate="academy.{{ currentCode }}.academy.description"
      ></p>
      <div class="button-academy">
        <button
          style="width: 118px;"
          (click)="openContactDialog(action.learnMore)"
          mat-flat-button
          color="accent"
          class="btn-more-academy"
        >
          {{ "more" | translate }}
        </button>
        <!--   <button
          mat-flat-button
          color="accent"
          (click)="downloadFormIndex()"
          class="btn-demo uppercase"
        >
          {{ "down" | translate }}
        </button> -->
      </div>
    </div>
    <div class="academy-img-siila" style="width:681px">
      <img
        *ngIf="!handsetMode"
        [alt]="imgAcademyAlt"
        [title]="imgAcademyAlt"
        [src]="imgAcademy()"
      />
      <img
        *ngIf="handsetMode"
        [alt]="imgAcademyAlt"
        [title]="imgAcademyAlt"
        [src]="imgAcademyMobile()"
      />
    </div>
  </div>
  <div
    *ngIf="!isMobile; else mobile"
    class="border-academy-white mat-elevation-z15"
  >
    <div class="siila-academy-img">
      <img
        [alt]="classesAlt"
        [title]="classesAlt"
        src="../../../../../assets/img/academy-list/academy-classes-MX-BR- all languages.png"
      />
    </div>
    <div class="siila-academy-info">
      <h2
        class="title-gnrl siila-blue-color"
        translate="academy.{{ currentCode }}.academy.what-is.title"
      ></h2>
      <h3
        class="siila-desc siila-menu-color"
        translate="academy.{{ currentCode }}.academy.what-is.sub-title"
      ></h3>
      <span
        class="academy-description siila-grey"
        translate="academy.{{ currentCode }}.academy.what-is.description"
      ></span>
    </div>
  </div>
  <ng-template #mobile>
    <div class="siila-academy-info mat-elevation-z15">
      <h2
        class="title-gnrl siila-blue-color"
        translate="academy.{{ currentCode }}.academy.what-is.title"
      ></h2>
      <h3
        class="siila-desc siila-menu-color"
        translate="academy.{{ currentCode }}.academy.what-is.sub-title"
      ></h3>
      <div class="siila-academy-img">
        <img
          [alt]="classesAlt"
          [title]="classesAlt"
          class="siila-img"
          src="../../../../../assets/img/academy-list/academy-classes-MX-BR- all languages.png"
        />
      </div>
      <p
        class="academy-description-head siila-grey"
        translate="academy.{{ currentCode }}.academy.what-is.description"
      ></p>
    </div>
  </ng-template>
  <div class="border-white mat-elevation-z15">
    <div class="news-info">
      <h2
        class="siila-desc siila-menu-color"
        translate="academy.{{ currentCode }}.academy.courses.sub-title"
      ></h2>
    </div>
    <div
      class="card-container-latam"
      *ngIf="
        currentCode == 'br' || currentCode == 'latam' || currentCode == 'mx'
      "
    >
      <button
        class="btn-slide"
        mat-basic-button
        #videoPrev
        aria-label="left arrow"
        (click)="changeSlideBack(slickCarousel)"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <ngx-slick-carousel
        class="carousel"
        #slickCarousel
        style="width: 92%;"
        [config]="slideConfig"
        (init)="slickInit($event)"
        (breakpoint)="breakpoint($event)"
        (afterChange)="afterChange($event)"
        (beforeChange)="beforeChange($event)"
      >
        <div
          ngxSlickItem
          *ngFor="let course of courseCarousel"
          class="slide"
          style="padding-bottom: 12px;"
        >
          <div class="card-items mat-elevation-z8" [style]="course.width">
            <img
              class="img-new"
              [ngClass]="{ 'img-new-contain': course.code === 'br-advanced' }"
              [src]="course.img"
              [alt]="course.alt"
              [title]="course.alt"
            />
            <div class="card-info-academy">
              <h4
                class="card-title siila-menu-color"
                [translate]="course.title"
              ></h4>
              <div class="innerText">
                <p
                  class="academy-description-head siila-grey"
                  [translate]="course.description"
                ></p>
              </div>

              <button
                *ngIf="course.showButton !== false"
                (click)="openCouse(course.code)"
                mat-flat-button
                color="accent"
                class="btn-more-academy uppercase"
              >
                {{ course.buttonLabel || "more" | translate }}
              </button>
              <div
                *ngIf="course.showButton === false"
                class="btn-more-academy no-button-spacer"
              ></div>
            </div>
          </div>
        </div>
      </ngx-slick-carousel>
      <button
        mat-basic-button
        #videoNext
        aria-label="right arrow"
        (click)="changeSlideNext(slickCarousel)"
        class="btn-slide"
        style="right: 0;"
      >
        <mat-icon *ngIf="!disableNext">chevron_right</mat-icon>
      </button>
    </div>
  </div>
  <div class="border-white mat-elevation-z15" *ngIf="currentCode == 'br'">
    <a (click)="openSponsorEmail()" style="cursor: pointer; display: block;">
      <img
        style="width: 100%;"
        [src]="getAcademySponsorImage()"
        [alt]="imgAcademyAlt"
        [title]="imgAcademyAlt"
      />
    </a>
  </div>
  <div class="border-about-card mat-elevation-z15">
    <div class="course-container">
      <h2
        style="white-space: nowrap;"
        class="siila-desc uppercase"
        translate="academy.{{ currentCode }}.academy.courses.about.title"
      ></h2>
      <div class="item-container">
        <div class="item-list" *ngFor="let item of aboutList">
          <img alt="" [src]="item.icon" />
          <span
            class="item-title"
            style="display: block;
          margin-left: 22px;
          margin-top: -18px;"
            [translate]="item.title"
          ></span>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="!isMobile; else contact"
    class="border-white mat-elevation-z15"
    style="padding: 40px;"
  >
    <div class="demo-card" style="margin-top: 0px !important;">
      <div class="img-contact">
        <img
          class="contact-img"
          [alt]="personmobile"
          [title]="personmobile"
          [src]="imgContactUs()"
        />
      </div>
      <div class="contact-info">
        <h2
          class="siila-desc siila-menu-color"
          translate="academy.{{ currentCode }}.academy.courses.contact.title"
        ></h2>
        <span
          class="academy-description siila-grey contactdesckkacademy"
          translate="academy.{{
            currentCode
          }}.academy.courses.contact.description"
        ></span>
        <form [formGroup]="form" class="contact-request formcontactkkacademy">
          <mat-form-field class="info-size">
            <mat-label class="name-text">{{
              "fullName" | translate
            }}</mat-label>
            <input matInput formControlName="fullName" />
          </mat-form-field>
          <mat-form-field class="info-size">
            <mat-label class="name-text">{{ "address" | translate }}</mat-label>
            <input matInput formControlName="email" />
          </mat-form-field>
          <mat-form-field class="info-size">
            <mat-label class="name-text">{{ "message" | translate }}</mat-label>
            <input matInput formControlName="description" />
          </mat-form-field>
          <div class="mt-10 phone-input-container">
            <ngx-intl-tel-input
              [cssClass]="
                'form-control' +
                (form.get('phone').invalid && form.get('phone').touched
                  ? ' is-invalid'
                  : '')
              "
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [customPlaceholder]="('phone' | translate) + ' *'"
              [searchCountryFlag]="true"
              [searchCountryField]="[
                SearchCountryField.Name,
                SearchCountryField.DialCode
              ]"
              [selectFirstCountry]="true"
              [maxLength]="15"
              formControlName="phone"
            ></ngx-intl-tel-input>
            <div
              *ngIf="form.get('phone').invalid && form.get('phone').touched"
              class="phone-error-message"
            >
              {{ "global.newsForm.invalidPhone" | translate }}
            </div>
          </div>
          <div
            *ngIf="imgCaptcha != '' && imgCaptcha != undefined"
            class="row mt-10 democatchakk"
          >
            <div>
              <img
                style="width: 200px;margin-left: 3px;"
                src="{{ imgCaptcha }}"
                alt=""
              />
              <span
                (click)="generateCaptcha()"
                style="color: rgba(0, 0, 0, 0.6); font-size: 15px;cursor: pointer;margin-left: 10px;color: #007bff;"
                >{{ "global.newsForm.reloadImg" | translate }}</span
              >
            </div>
            <div style="text-align: center; margin-top: -11px; padding: 15px;">
              <input
                formControlName="inputCaptcha"
                class="form-control"
                placeholder="{{
                  'global.newsForm.captchaPlaceholder' | translate
                }}"
                type="text"
              />
            </div>
            <label
              class="mt-2"
              style="color: red;"
              for=""
              *ngIf="errorCaptcha && form.controls.inputCaptcha.value == ''"
              >{{ "global.newsForm.verificationText" | translate }}</label
            >
            <label
              class="mt-2"
              style="color: red;"
              for=""
              *ngIf="
                errorCaptcha &&
                form.controls.inputCaptcha.value != '' &&
                form.controls.inputCaptcha.value != textCaptcha
              "
              >{{ "global.newsForm.verifyText" | translate }}</label
            >
          </div>
          <div class="academy-btn-touch">
            <button
              (click)="submitMessage()"
              mat-flat-button
              color="accent"
              class="btn-touch uppercase"
              [disabled]="
                form.invalid || form.controls.inputCaptcha.value != textCaptcha
              "
            >
              {{ "touchs" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <ng-template #contact>
    <div class="contact-container mat-elevation-z15">
      <div class="contact-info">
        <h2
          class="siila-desc siila-menu-color"
          translate="academy.{{ currentCode }}.academy.courses.contact.title"
        ></h2>
        <div class="img-contact">
          <img
            class="contact-img"
            [alt]="personmobile"
            [title]="personmobile"
            [src]="imgContactUs()"
          />
        </div>
        <h3
          class="academy-description siila-grey"
          translate="academy.{{
            currentCode
          }}.academy.courses.contact.description"
        ></h3>
        <div class="contact-request">
          <form [formGroup]="form">
            <mat-form-field class="info-size">
              <mat-label class="name-text">{{
                "fullName" | translate
              }}</mat-label>
              <input matInput formControlName="fullName" />
            </mat-form-field>
            <mat-form-field class="info-size">
              <mat-label class="name-text">{{
                "address" | translate
              }}</mat-label>
              <input matInput formControlName="email" />
            </mat-form-field>
            <mat-form-field class="info-size">
              <mat-label class="name-text">{{
                "message" | translate
              }}</mat-label>
              <input matInput formControlName="description" />
            </mat-form-field>
            <div class="mt-10 phone-input-container">
              <ngx-intl-tel-input
                [cssClass]="
                  'form-control' +
                  (form.get('phone').invalid && form.get('phone').touched
                    ? ' is-invalid'
                    : '')
                "
                [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true"
                [customPlaceholder]="('phone' | translate) + ' *'"
                [searchCountryFlag]="true"
                [searchCountryField]="[
                  SearchCountryField.Name,
                  SearchCountryField.DialCode
                ]"
                [selectFirstCountry]="true"
                [maxLength]="15"
                formControlName="phone"
              ></ngx-intl-tel-input>
              <div
                *ngIf="form.get('phone').invalid && form.get('phone').touched"
                class="phone-error-message"
              >
                {{ "global.newsForm.invalidPhone" | translate }}
              </div>
            </div>
            <div
              *ngIf="imgCaptcha != '' && imgCaptcha != undefined"
              class="row mt-10 democatchakk"
            >
              <div style="text-align: center;">
                <img style="width: 200px;" src="{{ imgCaptcha }}" alt="" />
                <div style="margin-top: 8px;">
                  <span
                    (click)="generateCaptcha()"
                    style="color: #007bff; font-size: 15px; cursor: pointer;"
                    >{{ "global.newsForm.reloadImg" | translate }}</span
                  >
                </div>
              </div>
              <div
                style="text-align: center; margin-top: -11px; padding: 15px;"
              >
                <input
                  formControlName="inputCaptcha"
                  class="form-control"
                  placeholder="{{
                    'global.newsForm.captchaPlaceholder' | translate
                  }}"
                  type="text"
                />
              </div>
              <label
                class="mt-2"
                style="color: red;"
                for=""
                *ngIf="errorCaptcha && form.controls.inputCaptcha.value == ''"
                >{{ "global.newsForm.verificationText" | translate }}</label
              >
              <label
                class="mt-2"
                style="color: red;"
                for=""
                *ngIf="
                  errorCaptcha &&
                  form.controls.inputCaptcha.value != '' &&
                  form.controls.inputCaptcha.value != textCaptcha
                "
                >{{ "global.newsForm.verifyText" | translate }}</label
              >
            </div>
            <div class="academy-btn-touch">
              <button
                (click)="submitMessage()"
                mat-flat-button
                color="accent"
                class="btn-touch uppercase"
                [disabled]="
                  form.invalid ||
                  form.controls.inputCaptcha.value != textCaptcha
                "
              >
                {{ "touchs" | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-template>
  <app-methodology></app-methodology>
  <!--  <app-featured-resources></app-featured-resources> -->
  <app-exclusive-access></app-exclusive-access>
  <app-btn-up></app-btn-up>
</section>
